import {NgModule, StaticProvider} from '@angular/core';
import {BrowserModule} from "@angular/platform-browser";
import {HttpClientModule} from "@angular/common/http";
import {platformBrowserDynamic} from "@angular/platform-browser-dynamic";
import {downgradeModule} from "@angular/upgrade/static";
import {AgentItineraryLinkComponent} from "./components/agent-itinerary-link/agent-itinerary-link.component";
import {CommonsModule} from "../../commons/angular/commons.module";
import {UserNamePipe} from "../../commons/angular/pipes/user-name.pipe";
import {AgentLocationComponent} from "./components/agent-location/agent-location.component";
import {NgbModule} from "@ng-bootstrap/ng-bootstrap";
import {TranslateModule} from "@ngx-translate/core";
import {AngularSvgIconModule} from "angular-svg-icon";
import {DragDropModule} from "@angular/cdk/drag-drop";
import {AgentItineraryEditListComponent} from "./components/agent-itinerary-edit-list/agent-itinerary-edit-list.component";
import {AgentItineraryEditListItemComponent} from "./components/agent-itinerary-edit-list-item/agent-itinerary-edit-list-item.component";
import {
  AgentItineraryTaskListComponent
} from "./components/agent-itinerary-task-list/agent-itinerary-task-list.component";
import { ScrollingModule as ScrollingModuleExperimental } from '@angular/cdk-experimental/scrolling';
import {ScrollingModule} from "@angular/cdk/scrolling";
import {TasksModule} from "../../tasks/angular/tasks.module";
import {AgentsListComponent} from "./components/agents-list/agents-list.component";
import {AgentsListItemComponent} from "./components/agents-list-item/agents-list-item.component";
import {AgentAvatarComponent} from "./components/agent-avatar/agent-avatar.component";
import {AgentStatusComponent} from "./components/agent-status/agent-status.component";
import {NgxPermissionsModule} from "ngx-permissions";
import {AgentAssistantModeComponent} from "./components/agent-assistant-mode/agent-assistant-mode.component";
import {AgentsMultiSelectComponent} from "./components/agents-multi-select/agents-multi-select.component";
import {AgentsMultiSelectListComponent} from "./components/agents-multi-select-list/agents-multi-select-list.component";
import {AgentTemperatureComponent} from "./components/agent-temperature/agent-temperature.component";
import {
  AgentScheduleImportTableComponent
} from "./components/agent-schedule-import-table/agent-schedule-import-table.component";
import {
  AgentScheduleColumnsSettingsPanelComponent
} from "./components/agent-schedule-columns-settings-panel/agent-schedule-columns-settings-panel.component";
import {
  agentConfigurationProfilesRequestsServiceProvider,
  agentDialogServiceProvider,
  agentsAlertsProvider,
  agentsServiceProvider,
  analyticsServiceProvider,
  attendanceRequestsServiceProvider,
  confirmDialogServiceProvider,
  latLngToAddressProvider,
  locationServiceProvider,
  firebaseServiceProvider,
  splitServiceProvider
} from "../../../providers";


@NgModule({
  declarations: [
    AgentItineraryLinkComponent,
    AgentLocationComponent,
    AgentItineraryEditListComponent,
    AgentItineraryEditListItemComponent,
    AgentItineraryTaskListComponent,
    AgentsListComponent,
    AgentsListItemComponent,
    AgentAvatarComponent,
    AgentStatusComponent,
    AgentAssistantModeComponent,
    AgentsMultiSelectComponent,
    AgentsMultiSelectListComponent,
    AgentTemperatureComponent,
    AgentScheduleImportTableComponent,
    AgentScheduleColumnsSettingsPanelComponent
  ],
  imports: [
    BrowserModule,
    HttpClientModule,
    CommonsModule,
    NgbModule,
    DragDropModule,
    ScrollingModuleExperimental,
    ScrollingModule,
    TasksModule,
    TranslateModule.forRoot(),
    NgxPermissionsModule.forChild(),
    AngularSvgIconModule.forRoot()
  ],
  providers: [
    UserNamePipe,
    agentsServiceProvider,
    splitServiceProvider,
    agentConfigurationProfilesRequestsServiceProvider,
    attendanceRequestsServiceProvider,
    confirmDialogServiceProvider,
    agentDialogServiceProvider,
    agentsAlertsProvider,
    analyticsServiceProvider,
    latLngToAddressProvider,
    locationServiceProvider,
    firebaseServiceProvider
  ],
    exports: [
        AgentItineraryLinkComponent,
        AgentLocationComponent,
        AgentItineraryEditListComponent,
        AgentsMultiSelectListComponent,
        AgentsMultiSelectComponent,
        AgentTemperatureComponent,
        AgentStatusComponent,
        AgentAvatarComponent,
        AgentAssistantModeComponent,
        AgentScheduleImportTableComponent
    ]
})

export class AgentsModule {
  constructor() {
  }

  ngDoBootstrap() {
  }
}

const bootstrapAgentsModule = (extraProviders: StaticProvider[]) => {
  const platformRef = platformBrowserDynamic(extraProviders);
  return platformRef.bootstrapModule(AgentsModule);
};

export const downgradedAgentsModule = downgradeModule(bootstrapAgentsModule);
